<template>
  <div class="cabrero-page">
    <section class="cabrero-page__header">
      <div class="cabrero-page__brands">
        <img
          class="cabrero-page__logo cabrero-page__logo--alumbra"
          src="/img/logo_alumbraenergia.webp"
          alt="Alumbra Energía"
        />
        <span class="cabrero-page__brand-divider" aria-hidden="true"></span>
        <img
          class="cabrero-page__logo cabrero-page__logo--cabrero"
          src="/img/automoviles_cabrero_logo.png"
          alt="Automóviles Cabrero"
        />
      </div>
      <div>
        <h1>Solicitud de cargador</h1>
      </div>
    </section>

    <section class="cabrero-page__body">
      <v-form ref="formulario" v-model="formularioValido" @submit.prevent="enviar">
        <div class="cabrero-page__panel">
          <div class="cabrero-page__panel-heading">
            <v-icon color="primary" size="38">mdi-account-circle</v-icon>
            <h2>Datos de contacto</h2>
          </div>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.nombre"
                label="Nombre y apellidos"
                autocomplete="name"
                outlined
                dense
                maxlength="255"
                hide-details="auto"
                :rules="[rules.req, rules.max255, rules.nombre]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.telefono"
                label="Teléfono"
                autocomplete="tel"
                inputmode="tel"
                outlined
                dense
                maxlength="12"
                hide-details="auto"
                :rules="[rules.req, rules.telefono]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.email"
                label="Email"
                autocomplete="email"
                inputmode="email"
                outlined
                dense
                maxlength="255"
                hide-details="auto"
                :rules="[rules.req, rules.max255, rules.email]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model.trim="form.direccion"
                label="Dirección / Ubicación"
                autocomplete="street-address"
                outlined
                dense
                maxlength="255"
                hide-details="auto"
                :rules="[rules.req, rules.max255, rules.direccion]"
              />
            </v-col>
          </v-row>
        </div>

        <div class="cabrero-page__panel">
          <div class="cabrero-page__panel-heading">
            <v-icon color="primary" size="38">mdi-ev-station</v-icon>
            <h2>Datos del cargador</h2>
          </div>

          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model.number="form.unidades"
                label="Unidades"
                type="number"
                min="1"
                max="50"
                outlined
                dense
                hide-details="auto"
                :rules="[rules.req, rules.unidades]"
              />
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model.number="form.distancia"
                label="Distancia cuadro-cargador"
                suffix="m"
                type="number"
                min="0"
                max="1000"
                step="0.1"
                outlined
                dense
                hide-details="auto"
                :rules="[rules.req, rules.distancia]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="form.tipo_conexion"
                :items="tiposConexion"
                label="Tipo de conexión"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                :rules="[rules.req]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="form.tipo_vivienda"
                label="Tipo de vivienda"
                :items="tiposVivienda"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                :rules="[rules.req]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                v-model="form.soporte"
                label="Soporte"
                :items="soportes"
                item-text="text"
                item-value="value"
                outlined
                dense
                hide-details="auto"
                :rules="[rules.req]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-switch
                v-model="form.cargador_portatil"
                label="Cargador portátil"
                inset
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model.trim="form.observaciones"
                label="Observaciones"
                rows="3"
                auto-grow
                outlined
                maxlength="255"
                hide-details="auto"
                :rules="[rules.observaciones]"
              />
            </v-col>
          </v-row>
        </div>

        <input
          v-model="form.honeypot"
          class="cabrero-page__honeypot"
          maxlength="255"
          tabindex="-1"
          autocomplete="off"
          aria-hidden="true"
        />

        <v-alert v-if="mensajeExito" type="success" outlined dense>
          {{ mensajeExito }}
        </v-alert>

        <v-alert v-if="mensajeError" type="error" outlined dense>
          {{ mensajeError }}
        </v-alert>

        <div class="cabrero-page__actions">
          <v-btn color="primary" type="submit" large depressed :loading="enviando">
            <v-icon left>mdi-send</v-icon>
            Enviar solicitud
          </v-btn>
        </div>
      </v-form>
    </section>
  </div>
</template>

<script>
const CABRERO_FORM_SLUG = "cabrero-cargador-2026-alumbra8cincoSIETE";

const formularioInicial = () => ({
  nombre: "",
  telefono: "",
  email: "",
  direccion: "",
  unidades: 1,
  tipo_conexion: "no_sabe",
  tipo_vivienda: "unifamiliar",
  soporte: "pared",
  cargador_portatil: false,
  distancia: null,
  observaciones: "",
  honeypot: "",
});

export default {
  name: "CabreroCargador",
  data() {
    return {
      temaOscuroPrevio: null,
      formularioValido: false,
      enviando: false,
      form: formularioInicial(),
      mensajeExito: "",
      mensajeError: "",
      tiposConexion: [
        { text: "Monofásico", value: "monofasico" },
        { text: "Trifásico", value: "trifasico" },
        { text: "No lo sé", value: "no_sabe" },
      ],
      tiposVivienda: [
        { text: "Unifamiliar", value: "unifamiliar" },
        {
          text: "Comunidad de propietarios",
          value: "comunidad_propietarios",
        },
        { text: "Otros", value: "otros" },
      ],
      soportes: [
        { text: "Pared", value: "pared" },
        { text: "Suelo", value: "suelo" },
      ],
      rules: {
        req: (v) => !!v || v === 0 || "Campo obligatorio",
        max255: (v) =>
          String(v || "").length <= 255 ||
          "Máximo 255 caracteres",
        nombre: (v) =>
          String(v || "").trim().length >= 2 ||
          "Indica el nombre y apellidos",
        direccion: (v) =>
          String(v || "").trim().length >= 3 ||
          "Indica la dirección o ubicación",
        email: (v) =>
          /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || "").trim()) ||
          "Email no válido",
        telefono: (v) => {
          const value = String(v || "").trim();
          return (
            /^(\d{9}|\+\d{11})$/.test(value) ||
            "Teléfono no válido. Usa 666666666 o +34666666666"
          );
        },
        unidades: (v) =>
          (Number(v) >= 1 && Number(v) <= 50) ||
          "Indica entre 1 y 50 unidades",
        distancia: (v) =>
          (Number(v) >= 0 && Number(v) <= 1000) ||
          "Indica una distancia válida",
        observaciones: (v) =>
          !v ||
          String(v).length <= 255 ||
          "Las observaciones son demasiado largas",
      },
    };
  },
  created() {
    this.temaOscuroPrevio = this.$vuetify.theme.dark;
    this.$vuetify.theme.dark = false;
  },
  beforeDestroy() {
    if (this.temaOscuroPrevio !== null) {
      this.$vuetify.theme.dark = this.temaOscuroPrevio;
    }
  },
  methods: {
    payload() {
      return {
        nombre: this.form.nombre,
        telefono: this.form.telefono,
        email: this.form.email,
        direccion: this.form.direccion,
        unidades: Number(this.form.unidades),
        tipo_conexion: this.form.tipo_conexion,
        tipo_vivienda: this.form.tipo_vivienda,
        soporte: this.form.soporte,
        cargador_portatil: Boolean(this.form.cargador_portatil),
        distancia: Number(this.form.distancia),
        observaciones: this.form.observaciones || null,
        honeypot: this.form.honeypot || null,
      };
    },
    mensajeErrorBackend(error) {
      const detail = error?.response?.data?.detail;

      if (Array.isArray(detail?.errores)) {
        return detail.errores.join(" ");
      }

      if (Array.isArray(detail)) {
        const errores = detail.map((error) => error?.msg).filter(Boolean).join(" ");
        if (errores) return errores;
      }

      if (typeof detail === "string") {
        return detail;
      }

      return "No se ha podido enviar la solicitud. Inténtalo de nuevo.";
    },
    async enviar() {
      this.mensajeExito = "";
      this.mensajeError = "";

      if (String(this.form.honeypot || "").trim()) {
        this.mensajeError = "No se ha podido validar el envío.";
        return;
      }

      if (!this.$refs.formulario.validate()) {
        this.mensajeError = "Revisa los campos marcados antes de continuar.";
        return;
      }

      this.enviando = true;

      try {
        const { data } = await window.axios({
          method: "POST",
          url: `${process.env.VUE_APP_API_URL}/formularios/cargador/${CABRERO_FORM_SLUG}`,
          data: this.payload(),
        });

        this.mensajeExito = data?.idEstudio
          ? `Solicitud enviada correctamente. Referencia ${data.idEstudio}.`
          : "Solicitud enviada correctamente.";
        this.form = formularioInicial();
        this.$nextTick(() => this.$refs.formulario.resetValidation());
      } catch (error) {
        this.mensajeError = this.mensajeErrorBackend(error);
      } finally {
        this.enviando = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cabrero-page {
  min-height: calc(100vh - 24px);
  background: #f6f7f8;
  color: #1f2933;
  padding: 32px 16px;
}

.cabrero-page__header,
.cabrero-page__body {
  max-width: 900px;
  margin: 0 auto;
}

.cabrero-page__header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 0 28px;
}

.cabrero-page__brands {
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 0 0 auto;
}

.cabrero-page__brand-divider {
  width: 1px;
  height: 50px;
  background: #d8dde3;
}

.cabrero-page__logo {
  width: 168px;
  max-width: 42vw;
  height: auto;
}

.cabrero-page__logo--cabrero {
  width: 190px;
  max-width: 44vw;
}

h1 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
}

.cabrero-page__panel {
  border: 1px solid #d8dde3;
  border-radius: 8px;
  background: #ffffff;
  margin-bottom: 18px;
  padding: 24px;
}

.cabrero-page__panel-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
}

h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.cabrero-page__honeypot {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.cabrero-page__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .cabrero-page {
    padding: 20px 12px;
  }

  .cabrero-page__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }

  .cabrero-page__brands {
    width: 100%;
    gap: 12px;
  }

  .cabrero-page__brand-divider {
    height: 40px;
  }

  .cabrero-page__logo {
    max-width: calc(50vw - 28px);
  }

  h1 {
    font-size: 1.6rem;
  }

  .cabrero-page__panel {
    padding: 18px;
  }

  .cabrero-page__actions {
    justify-content: stretch;
  }

  .cabrero-page__actions .v-btn {
    width: 100%;
  }
}
</style>
